(function() {
  var INITIAL_VISIBLE = 12;

  // Add items sequentially using the fetch API that UpCart intercepts
  // UpCart listens to the global fetch and intercepts /cart/add requests
  // The key is we must NOT redirect after - UpCart handles opening the drawer
  function addItemsSequentially(items, index, callback) {
    if (index >= items.length) {
      callback(null);
      return;
    }
    var item = items[index];
    // Build a form and submit it via fetch - UpCart intercepts this
    var formData = new FormData();
    formData.append('id', item.id);
    formData.append('quantity', item.quantity);
    fetch(window.Shopify.routes.root + 'cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
    .then(function() {
      addItemsSequentially(items, index + 1, callback);
    })
    .catch(function(e) {
      callback(e);
    });
  }

  function applyCardVisibility(bundle, activeCategory) {
    var cards = bundle.querySelectorAll('[data-card]');
    var visible = 0;
    var seeMoreWrap = bundle.querySelector('[data-see-more-wrap]');
    var seeMoreBtn = bundle.querySelector('[data-see-more]');
    var isExpanded = bundle.dataset.expanded === 'true';
    cards.forEach(function(card) {
      var matchesCategory = activeCategory === 'all' || card.dataset.category === activeCategory;
      if (!matchesCategory) { card.style.display = 'none'; return; }
      if (isExpanded || visible < INITIAL_VISIBLE) { card.style.display = ''; visible++; }
      else { card.style.display = 'none'; }
    });
    var totalInCategory = 0;
    cards.forEach(function(card) {
      if (activeCategory === 'all' || card.dataset.category === activeCategory) totalInCategory++;
    });
    if (seeMoreWrap) {
      if (!isExpanded && totalInCategory > INITIAL_VISIBLE) {
        seeMoreWrap.style.display = 'block';
        if (seeMoreBtn) seeMoreBtn.textContent = 'See all ' + totalInCategory + ' designs \u2193';
      } else { seeMoreWrap.style.display = 'none'; }
    }
  }

  function initBundles() {
    document.querySelectorAll('[data-card-bundle]').forEach(function(bundle) {
      if (bundle.dataset.bundleInit) return;
      bundle.dataset.bundleInit = 'true';
      bundle.dataset.expanded = 'false';
      var toggle = bundle.querySelector('[data-bundle-toggle]');
      var body = bundle.querySelector('[data-bundle-body]');
      var chevron = bundle.querySelector('[data-bundle-chevron]');
      var count = bundle.querySelector('[data-bundle-count]');
      var progress = bundle.querySelector('[data-bundle-progress]');
      var message = bundle.querySelector('[data-bundle-message]');
      var addButton = bundle.querySelector('[data-add-bundle]');
      var packButtons = bundle.querySelectorAll('[data-pack]');
      var tabButtons = bundle.querySelectorAll('[data-category]');
      var cards = bundle.querySelectorAll('[data-card]');
      var seeMoreBtn = bundle.querySelector('[data-see-more]');
      var activeCategory = 'all';
      var packSize = 3;
      var selected = [];

      applyCardVisibility(bundle, activeCategory);

      if (seeMoreBtn) {
        seeMoreBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          bundle.dataset.expanded = 'true';
          applyCardVisibility(bundle, activeCategory);
        });
      }

      toggle.addEventListener('click', function(e) {
        e.stopImmediatePropagation(); e.stopPropagation(); e.preventDefault();
        body.hidden = !body.hidden;
        chevron.classList.toggle('is-open', !body.hidden);
        toggle.setAttribute('aria-expanded', String(!body.hidden));
      }, true);
      toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); body.hidden = !body.hidden; chevron.classList.toggle('is-open', !body.hidden); }
      });

      function countOf(variantId) {
        return selected.filter(function(id) { return id === variantId; }).length;
      }

      function updateUI() {
        var remaining = packSize - selected.length;
        var complete = remaining === 0;
        if (count) count.textContent = selected.length + '/' + packSize;
        if (progress) progress.style.width = Math.min((selected.length / packSize) * 100, 100) + '%';
        if (message) { message.classList.toggle('is-complete', complete); message.textContent = complete ? 'Yay! Your card bundle is ready to add to cart.' : 'Pick ' + remaining + ' more card' + (remaining === 1 ? '' : 's') + ' to complete your bundle.'; }
        if (addButton) { addButton.disabled = !complete; addButton.textContent = complete ? '\uD83D\uDED2 Add ' + packSize + ' cards to cart' : 'Choose ' + remaining + ' more'; }
      }

      function refreshCardStates() {
        cards.forEach(function(card) {
          var variantId = card.dataset.variantId;
          var qty = countOf(variantId);
          var isSelected = qty > 0;
          var isFull = selected.length >= packSize;
          card.classList.toggle('is-selected', isSelected);
          card.disabled = !isSelected && isFull;
          card.classList.toggle('is-disabled', !isSelected && isFull);
          var tick = card.querySelector('[data-card-tick]');
          if (tick) tick.textContent = isSelected ? '\u2713' : '\u2661';
          var badge = card.querySelector('[data-card-qty]');
          if (badge) {
            if (qty > 1) { badge.textContent = '\u00d7' + qty; badge.classList.add('is-visible'); }
            else { badge.classList.remove('is-visible'); }
          }
        });
      }

      packButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          packButtons.forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          packSize = Number(btn.dataset.pack);
          selected = selected.slice(0, packSize);
          updateUI(); refreshCardStates();
        });
      });

      tabButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          tabButtons.forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          activeCategory = btn.dataset.category;
          bundle.dataset.expanded = 'false';
          applyCardVisibility(bundle, activeCategory);
        });
      });

      cards.forEach(function(card) {
        card.addEventListener('click', function(e) {
          e.preventDefault(); e.stopPropagation();
          var variantId = card.dataset.variantId;
          if (!variantId) return;
          var qty = countOf(variantId);
          if (qty > 0 && selected.length >= packSize) {
            var idx = selected.lastIndexOf(variantId);
            selected.splice(idx, 1);
          } else if (selected.length < packSize) {
            selected.push(variantId);
          }
          updateUI(); refreshCardStates();
        });
      });

      if (addButton) {
        addButton.addEventListener('click', function(e) {
          e.stopPropagation();
          addButton.textContent = 'Adding...';
          addButton.disabled = true;

          // Consolidate duplicates into quantity
          var itemMap = {};
          selected.forEach(function(id) { itemMap[id] = (itemMap[id] || 0) + 1; });
          var items = Object.keys(itemMap).map(function(id) { return { id: Number(id), quantity: itemMap[id] }; });

          // Add items sequentially using FormData - UpCart intercepts this format
          addItemsSequentially(items, 0, function(err) {
            if (err) {
              addButton.textContent = 'Error \u2014 try again';
              addButton.disabled = false;
              return;
            }
            // Reset bundle state
            selected = [];
            packButtons.forEach(function(b) { b.classList.remove('is-active'); });
            packButtons[0].classList.add('is-active');
            packSize = 3;
            updateUI(); refreshCardStates();
            addButton.textContent = '\u2713 Added!';
            setTimeout(function() { updateUI(); }, 2000);
            // UpCart should have opened its drawer automatically
            // as a fallback, try Dawn's drawer too
            setTimeout(function() {
              var cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                fetch('/?sections=cart-drawer,cart-icon-bubble')
                  .then(function(r) { return r.json(); })
                  .then(function(sections) { cartDrawer.renderContents({ sections: sections }); })
                  .catch(function() {});
              }
            }, 300);
          });
        });
      }
      updateUI();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initBundles(); setTimeout(initBundles, 800); });
  } else { initBundles(); setTimeout(initBundles, 800); }
})();
